import proj4 from 'proj4';

proj4.defs('EPSG:25829','+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs');
export const from4326_to25829 = (coords) => {
  if(coords) {
    return proj4('EPSG:4326', 'EPSG:25829', coords);
  }
};

